/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPublication = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 14a3.954 3.954 0 0 0-.887.107 3.973 3.973 0 0 0-.662.205c-.012.005-.021.012-.032.017-.144.062-.285.13-.419.208V5.005C5 4.451 5.451 4 6.005 4H19v10zm12 6H7c-1.103 0-2-.897-2-2s.897-2 2-2h12zM6.005 2A3.008 3.008 0 0 0 3 5.005V18c0 2.206 1.794 4 4 4h14V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPublication as Publication };
